import React, { FC, useState } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { IClub } from '../../../../store/player/clubs/store';

import Button from '../../../../components/Button';
import List from '../../../../components/Lists/List/List';
import MembershipCard from '../../../../components/MembershipCard';
import { PX } from '../../../../contrib/ui';

interface IProps {
  clubs: IClub[];
  onDelete: (clubId: number) => void;
}

const Memberships: FC<IProps> = props => {
  const { clubs } = props;

  const [open, setOpen] = useState(false);
  const [club, setClub] = useState<IClub>();

  const closeDialog = (): void => {
    setOpen(false);
  };

  const openDialog = (newClub: IClub) => () => {
    setOpen(true);
    setClub(newClub);
  };

  const deleteClub = (): void => {
    if (club) {
      props.onDelete(club.id);
    }

    setOpen(false);
  };

  return (
    <div className="membership-container">
      <h4 className="memberships-title">MY CLUB MEMBERSHIPS</h4>

      <List
        items={clubs}
        renderItem={withCallback(MembershipCard, openDialog)}
        itemHeight={0 * PX}
      />

      <Dialog
        open={open}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to leave?</DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to leave {club ? club.name : 'this club'}, you will not be able to see the
            club events, stats and players. Are you sure you want to continue?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeDialog} color="primary" id="cancel">
            NO, GO BACK
          </Button>

          <Button onClick={deleteClub} color="primary" autoFocus={true} id="delete">
            YES, PLEASE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const withCallback = (Comp: any, callback: any) => (props: any) => (
  <Comp {...props} onQuit={callback} />
);

export { Memberships };
